import React from 'react';

import { Box } from '@mui/material';

import DynamicFormGroup from 'components/DynamicFormGroup';
import Text from 'components/Text';
import { MenuItem, isFormExtras } from 'types/menuTypes';

interface FormListPageProps {
  formGroupId?: string;
  formGroupName?: string;
  menu: MenuItem;
}

const FormListPage: React.FC<FormListPageProps> = ({ formGroupId, formGroupName, menu }) => {
  // Get the group ID - use formGroupId if provided, otherwise extract from menu
  const groupId =
    formGroupId ||
    (menu?.feature?.extras && isFormExtras(menu.feature.extras)
      ? menu.feature.extras.form_group_id
      : null);

  if (!groupId) {
    return (
      <Text color="textSecondary" textAlign="center">
        ID do grupo não encontrado.
      </Text>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      {/* <TitleFormComponent title={formGroupName || 'Formulários'} /> */}
      <DynamicFormGroup group_id={groupId} />
    </Box>
  );
};

export default FormListPage;
